import { FC } from 'react';

import { CardData } from 'src/models/CardActivities/CardData';
import { DAILY_HABITS_CONFIG, ERROR_MESSAGES } from 'src/utils/constants';
import { SpotlightLayoutType, MediaType } from 'src/utils/enums';
import SpotlightCardContent, { SpotlightContent } from '../spotlight-card-content/SpotlightCardContent';
import { useDailyHabitsSpotlightStyles } from './DailyHabitsSpotlight.styles';

interface Props {
  card: CardData
}

const DailyHabitsSpotlight: FC<Props> = ({ card }) => {
  const styles = useDailyHabitsSpotlightStyles();

  const { templateData } = card;
  if (!templateData) return null;

  if (!templateData.experienceId || !(templateData.experienceId in DAILY_HABITS_CONFIG)) {
    throw new Error(ERROR_MESSAGES.invalidExperienceType(templateData?.experienceId));
  }

  const { icon: DailyHabitIcon, color }
    = DAILY_HABITS_CONFIG[templateData.experienceId as keyof typeof DAILY_HABITS_CONFIG];
  const dailyHabitIcon = (
    <span className={styles.icon}>
      <DailyHabitIcon color={color} />
    </span>
  );

  const content: SpotlightContent = {
    headline: templateData.headline,
    bodyHeader: templateData.bodyHeader,
    body: templateData.body,
    callToAction: templateData.callToAction,
    actionURL: templateData.actionURL,
    badgeIcon: dailyHabitIcon,
    mediaUrl: templateData.image,
    mediaType: MediaType.IMAGE,
  };

  return (
    <div data-testid="daily-habits-spotlight">
      <SpotlightCardContent content={content} layoutType={SpotlightLayoutType.TEXT_LEFT_MEDIA_RIGHT} />
    </div>
  );
};

export default DailyHabitsSpotlight;
